// Potwierdzenie odbioru osobistego przesyłki WYCHODZĄCEJ (forma doręczenia „Odbiór
// osobisty" = ParcelDeliveryCategory.PersonalPickup; adresat odbiera przesyłkę osobiście
// przy okienku). Odwzorowanie formatki Magistratu (Kwantum.Parcels.UI/DirectDispatch):
// data odbioru, kto odebrał (imię/nazwisko + dokument tożsamości), znacznik „nie odebrano"
// oraz skan/plik potwierdzenia (dowód) doszywany do przesyłki.

/**
 * Rodzaj dokumentu tożsamości (BE Core.Enums.IdDocumentType). Odwzorowanie
 * magistrackiego `Kwantum.Enums.IDType` — który definiuje dokładnie te 2 pozycje.
 */
export enum EIdDocumentType {
  IdCard = 0,
  Passport = 1,
}

export const ID_DOCUMENT_TYPE_LABELS: Record<EIdDocumentType, string> = {
  [EIdDocumentType.IdCard]: "Dowód osobisty",
  [EIdDocumentType.Passport]: "Paszport",
};

export interface IConfirmPickupRequest {
  ParcelId: string;
  /** Data odbioru (ISO). */
  PickupDate: string;
  /** „Przesyłki nie odebrano" — pomija dane odbierającego. */
  NotCollected: boolean;
  FirstName?: string | null;
  LastName?: string | null;
  /** EIdDocumentType (int) — rodzaj dokumentu tożsamości. */
  IdDocumentType?: number | null;
  IdDocumentNumber?: string | null;
  /** Skan/plik potwierdzenia (dowód) — model FileUri + KeyId. */
  ScanFileUri?: string | null;
  ScanKeyId?: string | null;
}

export interface IPickupInfo {
  IsConfirmed: boolean;
  PickupDate?: string | null;
  NotCollected: boolean;
  FirstName?: string | null;
  LastName?: string | null;
  IdDocumentType?: number | null;
  IdDocumentNumber?: string | null;
  HasConfirmationScan: boolean;
  ScanFileUri?: string | null;
  ScanKeyId?: string | null;
}
